module.exports = __webpack_public_path__ + "static/media/guitar-course.8f5b6628.jpg";